// extracted by mini-css-extract-plugin
export default {"headerBar":"HY-z","pointsSection":"IY-z","goToDashboard":"JY-z"};